import { motion } from "framer-motion";
import { BrainCircuit, ChartNoAxesCombined, Rocket } from "lucide-react";
import { teamOfficeUrl } from "@/components/equinox/data";
const aboutHighlights = [
  {
    title: "AI-first growth company",
    icon: BrainCircuit,
    text: "Equinox combines marketing, automation, attribution, and product thinking into one growth operating layer.",
  },
  {
    title: "70+ apps experience",
    icon: ChartNoAxesCombined,
    text: "The team has worked across fintech, payments, commerce, and content-led products with measurable outcomes.",
  },
  {
    title: "Outcome-driven execution",
    icon: Rocket,
    text: "The focus stays on installs, CAC, conversion, ratings, and revenue — not generic activity reporting.",
  },
];

export default function AboutPage() {
  return (
    <section className="px-6 pb-20 pt-16 sm:px-8 lg:px-12 lg:pb-28 lg:pt-20">
      <div className="mx-auto max-w-7xl">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }} className="grid gap-10 lg:grid-cols-[1fr_0.9fr] lg:items-center">
          <div>
          <p className="section-kicker">About Equinox</p>
          <h1 className="section-heading mt-5 text-white">A systems-first growth agency built for execution.</h1>
          <p className="section-copy mt-6 text-white/[0.66]">
            Equinox is positioned around one belief: growth should behave like an operating system, not a collection of disconnected campaigns. We work across acquisition, conversion, ratings, and funnel quality with an AI-first execution mindset.
          </p>
          <p className="section-copy mt-4 text-white/[0.66]">
            With experience across 70+ apps, the focus stays on doing the work that changes outcomes — lower CAC, stronger install growth, better ratings, and more reliable scale.
          </p>
          </div>

          <div className="overflow-hidden rounded-[2rem] border border-white/[0.08] bg-black/20 p-3">
            <img src={teamOfficeUrl} alt="Equinox office team" className="aspect-[4/5] w-full rounded-[1.5rem] object-cover grayscale" data-testid="about-team-image" />
          </div>

          <div className="lg:col-span-2 mt-4 grid gap-4 sm:grid-cols-3">
            {aboutHighlights.map(({ title, icon: Icon, text }) => (
              <div key={title} className="glitter-card glass-panel cinematic-card rounded-[1.7rem] p-5" data-testid={`about-highlight-${title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-2xl border border-white/[0.12] bg-gradient-to-br from-white/10 to-blue-500/16 text-white">
                  <Icon className="h-5 w-5" />
                </div>
                <p className="font-display text-xl text-white">{title}</p>
                <p className="mt-3 text-sm leading-7 text-white/[0.62]">{text}</p>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}